/**
 * The search field shown in the incoming shipments table's action bar for the new view.
 */

import React, { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import SearchField from "@amzn/meridian/search-field"
import useIncomingShipmentsFiltersNew from "../../hooks/use-incoming-shipments-filters-new"

const IncomingShipmentsSearchFieldNew = props => {
  const { filters, dispatch } = useIncomingShipmentsFiltersNew()
  const [query, setQuery] = useState("")
  const filterValue = filters.get("allFields")?.value || ""

  const search = useCallback(
    value =>
      value
        ? dispatch({
            type: "UPDATE_FILTER",
            filter: "allFields",
            value,
            tagLabel: `${value}`,
          })
        : dispatch({
            type: "REMOVE_FILTER",
            filter: "allFields",
          }),
    [dispatch]
  )

  // Debounce calls to onSearch
  useEffect(() => {
    const timeout = setTimeout(() => search(query), 300)
    return () => clearTimeout(timeout)
  }, [query, search])

  useEffect(() => {
    setQuery(filterValue)
  }, [filterValue])

  return (
    <SearchField
      placeholder={
        props.mobile ? "Search" : "Search"
      }
      value={query}
      onChange={setQuery}
      onSubmit={search}
      onClear={search}
      searchButton={true}
      width={props.mobile ? 200 : 360}
    />
  )
}

IncomingShipmentsSearchFieldNew.propTypes = {
  mobile: PropTypes.bool,
}

IncomingShipmentsSearchFieldNew.defaultProps = {
  mobile: false,
}

export default IncomingShipmentsSearchFieldNew
